export default __webpack_public_path__ + "static/media/SoumyaBhave.4073958f.png";